// extracted by mini-css-extract-plugin
export default {"root":"OJZT8YAtGfVL6DqLnhW1"};